var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0.39624H0V40.3962H40V0.39624Z",
    fill: "#231E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9586 7.06287C12.6191 7.06287 6.66602 12.9907 6.66602 20.2991C6.66602 26.1458 10.4988 31.0992 15.718 32.8857C16.3704 32.9669 16.615 32.5609 16.615 32.2361C16.615 31.9112 16.615 31.0992 16.615 29.9624C12.9453 30.7744 12.1298 28.1759 12.1298 28.1759C11.559 26.633 10.6619 26.227 10.6619 26.227C9.4387 25.4149 10.7435 25.4149 10.7435 25.4149C12.0483 25.4961 12.7822 26.7954 12.7822 26.7954C14.0055 28.8255 15.8811 28.2571 16.615 27.9323C16.6966 27.039 17.1043 26.4706 17.4305 26.1458C14.4948 25.821 11.3959 24.6841 11.3959 19.5683C11.3959 18.1066 11.8852 16.9697 12.7822 15.9953C12.7007 15.7517 12.2114 14.3712 12.9453 12.5847C12.9453 12.5847 14.087 12.2599 16.615 13.9652C17.6752 13.6404 18.8169 13.5592 19.9586 13.5592C21.1003 13.5592 22.242 13.7216 23.3021 13.9652C25.8301 12.2599 26.9718 12.5847 26.9718 12.5847C27.7058 14.3712 27.2165 15.7517 27.1349 16.0765C27.9504 16.9697 28.5213 18.1878 28.5213 19.6495C28.5213 24.7653 25.4224 25.821 22.4866 26.1458C22.9759 26.5518 23.3836 27.3638 23.3836 28.5819C23.3836 30.3684 23.3836 31.7488 23.3836 32.2361C23.3836 32.5609 23.6283 32.9669 24.2807 32.8857C29.5814 31.0992 33.3327 26.1458 33.3327 20.2991C33.2511 12.9907 27.298 7.06287 19.9586 7.06287Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.89624,
    width: 39,
    height: 39,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_185"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.39624,
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.e4efe682ae1e0cd485a9af30db52f78c.svg";
export { ForwardRef as ReactComponent };